import {HttpClient,HttpErrorResponse,HttpHeaders} from '@angular/common/http';

export function serializeData(data){
	var buffer = [];
        
        // Serialize each key in the object.
        for ( var name in data ) {
            if ( ! data.hasOwnProperty( name ) ) {
                continue;
            }
            
            var value = data[ name ];     
            if (typeof value=='object'){
                value = JSON.stringify(value)
            }
            buffer.push(
                encodeURIComponent( name ) +
                "=" +
                encodeURIComponent( ( value == null ) ? "" : value )
            );
            
            
        }

        // Serialize the buffer and clean it up for transportation.
        var source = buffer.join( "&" ).replace( /%20/g, "+" );

        return( source );
}



export const headers = {
    headers: new HttpHeaders({
       'Content-Type': "application/x-www-form-urlencoded;charset=UTF-8"
    }),
    withCredentials: true
}